const doc = [({"da":({"js":({"users":({"consent":({"index":({"i_consent_to_the_terms":"Jeg er enig i betingelserne", "the_settings_were_saved":"Indstillingerne blev gemt"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;